import { IUpdateRateioGeralUseCase } from "../../../presentation/useCases/update/update_rateio_geral_use_case";
import { RateioGeralLista } from "../../models/rateio_geral_listas";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * UpdateRateioGeralUseCase
 */

export class UpdateRateioGeralUseCase implements IUpdateRateioGeralUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async updateRateioGeral(form: RateioGeralLista[]): Promise<void> {
    return this.repository.updateRateioGeral(form);
  }
}
